import { errors } from 'redux-rest-reducer';
import { ACTIONS } from 'actions/events-tracker';
import { ACTIONS as logoutActions } from 'actions/logout';

import { getEventData } from 'modules/student-alerts/events-data-wrapper';

const initialState = {
  callOngoing: false,
  doubtRaised: !!getEventData('doubtsAlert'),
  timedSheetOpened: false,
  callEventTime: Number(getEventData('callEventTime')),
};

export default function defaultExport(state = initialState, { type, payload }) {
  switch (type) {
    case ACTIONS.UPDATE_EVENT_STATUS: {
      return {
        ...state,
        ...payload,
      };
    }
    case logoutActions.POST_SUCCESS:
    case errors[401]:
      return initialState;
    default:
      return state;
  }
}
